<script>
import settings from '@shared/settings'
import CacheMixin from '@shared/mixins/CacheMixin'

export default {
  mixins: [CacheMixin],
  data() {
    return {
      notificationHandlerMap: {
        LOAN_APPLICATION_APPROVED: this.navigateToLoanApplicationTimeline,
        LOAN_APPLICATION_REJECTED: this.navigateToLoanApplicationTimeline,
        IDENTITY_VERIFICATION_NEEDS_REVIEW: this.navigateToLoanApplicationTimeline,
        IDENTITY_VERIFICATION_SUCCESS: this.navigateToLoanApplicationTimeline,
        LOAN_PAYOUT_APPROVED: this.navigateToLoanApplicationTimeline,
        LOAN_REPAYMENT_IS_OVERDUE: this.navigateToLoanDetails,
        LOAN_HAS_BEEN_CLOSED: this.navigateToLoanDetails,
        LOAN_REPAYMENT_RECEIVED: this.onLoanRepaymentReceived,
        NEW_LOAN_OFFER_RECEIVED: this.onNewLoanOfferReceived,
        NEW_PREAPPROVED_LOAN_OFFER_RECEIVED: this.onNewPreApprovedLoanOfferReceived
      }
    }
  },
  methods: {
    handlePushNotification(notification) {
      if (notification.type in this.notificationHandlerMap) {
        this.notificationHandlerMap[notification.type](notification)
      }
    },
    navigateToLoanApplicationTimeline(notification) {
      this.resetCache().then(() => {
        this.$router.push({ name: 'loan-application', params: { id: notification.reference } })
      })
    },
    navigateToLoanDetails(notification) {
      this.resetCache().then(() => {
        this.$router.push({ name: 'loan', params: { id: notification.reference } })
      })
    },
    onLoanRepaymentReceived() {
      this.resetCache().then(() => {
        this.$router.push({ name: 'customer-overview' })
      })
    },
    onNewLoanOfferReceived() {
      this.resetCache().then(() => {
        this.$router.push({ name: 'customer-overview' })
      })
    },
    onNewPreApprovedLoanOfferReceived(notification) {
      this.resetCache().then(() => {
        const query = settings.isAppToBrowserRedirectEnabled() ? { w: '' } : {}
        this.$router.push({ name: 'loan-form-with-offer-id', params: { offerId: notification.id }, query })
      })
    }
  }
}
</script>
